(function () {
  'use strict';

  const API_URL = 'https://bos-configurator-ocjjh.ondigitalocean.app';
  const STORAGE_KEY = 'productConfigurations';
  const CONFIGURATOR_MARKER = '_configurator';
  const METADATA_KEYS = ['_configurator', '_configurator_version', '_product_title', '_product_handle'];

  // ─── Helpers ──────────────────────────────────────────────────────────────

  function getLocalConfig(variantId) {
    try {
      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
      return saved[String(variantId)] || saved[Number(variantId)] || null;
    } catch {
      return null;
    }
  }

  async function getServerConfig(variantId) {
    try {
      const storeKey = window.CONFIGURATOR_STORE_KEY || '';
      const url = storeKey
        ? `${API_URL}/api/config/${variantId}?store=${encodeURIComponent(storeKey)}`
        : `${API_URL}/api/config/${variantId}`;
      const res = await fetch(url);
      if (!res.ok) return null;
      return await res.json();
    } catch {
      return null;
    }
  }

  function hasStepProperties(properties) {
    return Object.keys(properties).some(k => !METADATA_KEYS.includes(k));
  }

  async function restoreProperties(key, quantity, properties) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: String(key), quantity, properties }),
    });
    if (!res.ok) throw new Error(`cart/change.js ${res.status}`);
    return res.json();
  }

  async function removeFromCart(key) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: String(key), quantity: 0 }),
    });
  }

  function buildConfiguratorUrl(productHandle, selections) {
    const params = new URLSearchParams(selections);
    return `/products/${productHandle}?${params}`;
  }

  // ─── Core check ───────────────────────────────────────────────────────────

  async function checkCart() {
    const cartRes = await fetch('/cart.js');
    if (!cartRes.ok) return false;
    const cart = await cartRes.json();
    if (!cart.items?.length) return false;

    for (const item of cart.items) {
      const props = item.properties || {};
      const hasMarker = props[CONFIGURATOR_MARKER] === 'true';
      const hasAnyProps = Object.keys(props).length > 0;

      // ── Scenario A: heeft marker maar mist step-properties ──────────────
      if (hasMarker && !hasStepProperties(props)) {
        console.log('[Config Recovery] Item met marker maar zonder step-properties:', item.product_title);

        const localConfig = getLocalConfig(item.variant_id);
        if (localConfig?.properties) {
          console.log('[Config Recovery] Herstel vanuit localStorage...');
          try {
            await restoreProperties(item.key, item.quantity, localConfig.properties);
            console.log('[Config Recovery] Herstel gelukt:', item.product_title);
            return true;
          } catch (err) {
            console.warn('[Config Recovery] Herstel mislukt:', err);
          }
        }

        const serverConfig = await getServerConfig(item.variant_id);
        if (serverConfig) {
          console.log('[Config Recovery] Config gevonden op server, redirect naar configurator...');
          await removeFromCart(item.key);
          window.location.href = buildConfiguratorUrl(serverConfig.productHandle, serverConfig.selections);
          return false;
        }

        console.warn('[Config Recovery] Geen config gevonden voor:', item.variant_id);
      }

      // ── Scenario B: helemaal geen properties → check server ─────────────
      if (!hasAnyProps) {
        const serverConfig = await getServerConfig(item.variant_id);
        if (serverConfig) {
          console.log('[Config Recovery] Gegenereerd product zonder properties (bijv. opnieuw kopen). Redirect...');
          await removeFromCart(item.key);
          window.location.href = buildConfiguratorUrl(serverConfig.productHandle, serverConfig.selections);
          return false;
        }
      }
    }

    return false;
  }

  // ─── Checkout interceptor ─────────────────────────────────────────────────

  function interceptCheckout() {
    document.addEventListener('click', async function (e) {
      const link = e.target.closest('a[href="/checkout"], a[href*="/checkouts/"]');
      if (!link) return;

      e.preventDefault();
      e.stopPropagation();

      console.log('[Config Recovery] Checkout onderschept, cart controleren...');

      try {
        const needsReload = await checkCart();
        if (needsReload) {
          window.location.reload();
        } else {
          window.location.href = link.href;
        }
      } catch (err) {
        console.error('[Config Recovery] Fout bij checkout check:', err);
        window.location.href = link.href;
      }
    }, true);
  }

  // ─── Init ─────────────────────────────────────────────────────────────────

  function init() {
    interceptCheckout();

    if (window.location.pathname.includes('/cart')) {
      const run = () => setTimeout(async () => {
        try {
          const needsReload = await checkCart();
          if (needsReload) {
            console.log('[Config Recovery] Properties hersteld, pagina herladen...');
            setTimeout(() => window.location.reload(), 300);
          }
        } catch (err) {
          console.error('[Config Recovery] Fout bij cart check:', err);
        }
      }, 1000);

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run);
      } else {
        run();
      }
    }

    document.addEventListener('cart:updated', () => checkCart());
    document.addEventListener('cart:refresh', () => checkCart());
  }

  init();

  if (window.location.hostname === 'localhost' || window.location.hostname.includes('myshopify.com')) {
    window.debugConfigRecovery = async function () {
      console.log('=== CONFIG RECOVERY DEBUG ===');
      const local = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
      console.log('LocalStorage configs:', Object.keys(local).length, Object.keys(local));
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      for (const item of cart.items) {
        const props = item.properties || {};
        console.log({
          title: item.product_title,
          variantId: item.variant_id,
          key: item.key,
          hasMarker: props[CONFIGURATOR_MARKER] === 'true',
          propertyCount: Object.keys(props).length,
          hasStepProps: hasStepProperties(props),
          localConfig: !!getLocalConfig(item.variant_id),
        });
      }
      console.log('=== EINDE DEBUG ===');
    };
  }
})();
